<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      title="装箱信息"
      id-key="Id"
      @edit-opened="opened"
      :line-form="true"
      form-label-width="85px"
      :save-func="() => {}"
      @close-saved="$emit('close-saved')"
      :confirm-on-close-change="false"
      :modal-append-to-body="false"
      in-dialog
    >
      <template slot="form">
        <el-row class="border">
          <el-form>
            <el-row>
              <el-col :span="5">
                <el-form-item label="销售单号" prop="OrderNo">
                  <div class="detail-span">{{ data.OrderNo ?? data.SourceNo }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="存货名称" prop="ProductName">
                  <div class="detail-span">{{ data.ProductName }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="批号" prop="BatchNumber">
                  <div class="detail-span">{{ data.BatchNumber }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="存货条码" prop="Barcode">
                  <div class="detail-span">{{ data.Barcode||data.BarCode }}</div>
                </el-form-item>
              </el-col> </el-row
            ><el-row>
              <el-col :span="5">
                <el-form-item label="数量" prop="Quantity">
                  <div class="detail-span">{{ data.BaseQuantity ?? data.Quantity }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="单位" prop="SaUnitName">
                  <div class="detail-span">{{ data.SaUnitName ?? data.UnitName }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="数量2" prop="Quantity2">
                  <div class="detail-span">{{ data.Quantity2 }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="单位2" prop="UnitName2">
                  <div class="detail-span">{{ data.UnitName2 }}</div>
                </el-form-item>
              </el-col>
            </el-row></el-form
          >
        </el-row>
        <el-table border :data="tableData" @selection-change="onSelectGoods" class="tableList">
          <el-table-column type="selection" width="35" />
          <el-table-column label="批号" min-width="140px" prop="BatchNumber" align="left">
            <template slot-scope="{ row }">
              <span>{{ row.BatchNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column label="条码" min-width="100px" prop="BarCode" align="left">
            <template slot-scope="{ row }">
              <span>{{ row.BarCode }}</span>
            </template>
          </el-table-column>
          <el-table-column label="仓库" prop="WarehouseName" align="right">
            <template slot-scope="{ row }">
              <span>{{ row.WarehouseName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="颜色" prop="ColorName" align="right">
            <template slot-scope="{ row }">
              <span>{{ row.ColorName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="属性" prop="PropertyName" align="right">
            <template slot-scope="{ row }">
              <span>{{ row.PropertyName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="装箱规格" prop="SpeciName" align="right">
            <template slot-scope="{ row }">
              <span>{{ row.SpeciName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="每件数" prop="RealPackingNumber" align="right">
            <template slot-scope="{ row }">
              <span>{{ row.RealPackingNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column label="件数" prop="PackingQuantity" align="right">
            <template slot-scope="{ row }">
              <span>{{ row.PackingQuantity }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位" prop="BaseUnitName" align="right">
            <template slot-scope="{ row }">
              <span>{{ row.BaseUnitName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="数量" prop="BaseQuantity" align="right">
            <template slot-scope="{ row }">
              <span>{{ row.BaseQuantity }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="save">确定</el-button>
        <el-button @click="closeDialog">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
  <script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import item from '@/api/ba/item'
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog
  },
  data() {
    return {
      data: {},
      tableData: [],
      currentRowPrice: 0,
      currentId: 0,
      api: require('@/api/stock/stProductPackingStock').default
      // trendData: iForm.Data,
    }
  },
  methods: {
    onSelectGoods(row) {
      this.selectGoods = row
    },
    opened(row) {
      this.data = row
      console.log(row, row.ProductId, 'opened')
      this.api.list({ ProductId: this.data.ProductId, BatchNumber: this.data.BatchNumber, PropertyId: this.data.PropertyId, ColorId: this.data.ColorId, PageIndex: 1, PageSize: 10 ,IsInOut:1}).then(res => {
        if (res.Code === 0) {
          this.tableData = res.Data
        }
      })
    },
    save() {
      if (this.selectGoods.length == 0) {
        this.$message.warning('请选择装箱信息')
        return
      }
      var list = []
      this.selectGoods.forEach(item => {
        list.push({
          ...this.data,
          PackingQuantity: item.PackingQuantity,
          PackingNumber: item.PackingNumber,
          RealPackingNumber: item.RealPackingNumber,
          RealQuantity: item.BaseQuantity,
          RealQuantity2: item.SubQuantity,
          PackingSpeciId: item.PackingSpeciId,
          PropertyId: item.PropertyId,
          ColorId: item.ColorId,
          Barcode: item.BarCode,
          BarCode: item.BarCode,
          SpeciName: item.SpeciName
        })
      })
      this.$emit('save', { list, index: this.data.index })
      this.close()
    },
    closeDialog() {
      this.close()
    }
  }
}
</script>
  
  <style lang="scss">
.box {
  margin-top: 8px;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: transparent !important;
}
</style>
  